import * as yup from 'yup';

const LeadSourcesSettingsSchema = yup.object().shape({
    leadSource: yup.string().required(),
});

export default LeadSourcesSettingsSchema;
